import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/helpers/classNames"

const labelVariants = cva(
  `
    font-label-medium text-sm leading-none
    peer-disabled:cursor-not-allowed peer-disabled:opacity-70
  `,
  {
    variants: {
      variant: {
        disabled: "text-neutral-400",
      },
    },
  },
)

type Props = {
  disabled?: boolean
  // Following props are added to shadcn/ui component
  required?: boolean
  variant?: "disabled"
} & React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>

function Label({
  children,
  className,
  ref,
  required,
  variant,
  ...props
}: {
  ref?: React.Ref<React.ElementRef<typeof LabelPrimitive.Root>>
} & Props &
  VariantProps<typeof labelVariants>) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(labelVariants({ variant }), className)}
      {...props}
    >
      {children}
      {required && <span className="text-danger-300">*</span>}
    </LabelPrimitive.Root>
  )
}

export { Label }
